import { Tooltip } from "@mui/material";

export const assemblyStatusCodes = [
	{ Code: "E", Name: "Empty", Color: "#f1f5f9", TextColor: "#2E2E2E" },
	{
		Code: "A",
		Name: "Build In Progress",
		Color: "#eab308",
		TextColor: "#2E2E2E",
	},
	{ Code: "C", Name: "Completed", Color: "#2563eb", TextColor: "#FFFFFF" },
	{ Code: "S", Name: "Signed Off", Color: "#9333ea", TextColor: "#FFFFFF" },
	{ Code: "I", Name: "Installed", Color: "#1f2937", TextColor: "#FFFFFF" },
	{ Code: "U", Name: "Uninstalled", Color: "#dc2626", TextColor: "#FFFFFF" },
	{ Code: "F", Name: "Finished", Color: "#aaacafff", TextColor: "#2E2E2E" },
];

type StatusTagProps = {
	status?: { Code: string; Name: string; Color: string; TextColor: string };
};

export const CarrierAssemblyStatusTag = ({ status }: StatusTagProps) => {
	if (!status || !status.Code || !status.Name) {
		return null;
	}

	let backgroundColor = assemblyStatusCodes.find(
		(code) => code.Code === status.Code,
	)?.Color;

	return (
		<Tooltip title={status.Name} arrow>
			<div
				style={{
					width: "26px",
					height: "26px",
					borderRadius: 4,
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					fontWeight: "bold",
					backgroundColor,
					color: status.TextColor,
				}}
			>
				{status.Code.charAt(0).toUpperCase()}
			</div>
		</Tooltip>
	);
};
